import { useState, useEffect } from "react";
import MobileApp from "./MobileApp.tsx";
import WebApp from "./WebApp.tsx";

const MOBILE_BREAKPOINT = "(max-width: 767px)";

/**
 * Root component - ONLY place where platform detection occurs
 *
 * Detects viewport size and renders appropriate platform-specific app:
 * - Mobile (< 768px): MobileApp with full-screen settings pages
 * - Desktop (>= 768px): WebApp with modal-based settings
 *
 * Uses matchMedia API for efficient, debounce-free platform detection.
 * This is the single source of truth for platform detection.
 * NO other component should check viewport or have platform conditionals.
 */
function Root() {
  const [isMobile, setIsMobile] = useState(
    () => window.matchMedia(MOBILE_BREAKPOINT).matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_BREAKPOINT);
    const handleChange = (e: MediaQueryListEvent) => {
      setIsMobile(e.matches);
    };

    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  return isMobile ? <MobileApp /> : <WebApp />;
}

export default Root;
